<template>
  <div id="app2">
      <Contact></Contact>
  </div>
</template>

<script>
import Contact from './components/Contact';

export default {
  name: 'AppC',
  components: {
    Contact,
  }
}
</script>
